import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ConnectionRequestBox from 'components/ConnectionRequestBox';
import QuickLinksBox from 'components/QuickLinksBox';
import { Container, Nav, Stack } from 'react-bootstrap';
import Profile from 'components/UserBox/Profile';
import LeftMenus from 'components/UserBox/LeftMenus';
import RecentMessages from 'components/RecentMessages';
import HashtagsBox from 'components/HashtagsBox';
import JobsForYou from 'components/JobsForYou';
import { isMobile } from 'react-device-detect';
import Header from 'components/Common/Header/Header';
import useChatStore from 'store/chat';
import useAuthStore from 'store/auth';
import { USER_TYPES } from 'constants/index';
import Banner from 'components/Home/Banner';

const SocialLayout: React.FC = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const recentMessages = useChatStore((state) => state.userList);
	const { user: authUser, token }: Record<string, any> = useAuthStore(
		(state) => state.userInfo ?? {},
	);

	const handleSelect = (value: string | null) => {
		if (value) {
			navigate(value);
		}
	};

	return (
		<>
			<Header />
			<section id="infiniteDiv-social-feeds" className="job-seeker-profile py-50">
				{!token && <Banner />}
				<Container fluid>
					<div className="d-flex flex-column flex-xl-row gap-3 gap-xxl-4">
						<div className="left-area d-flex flex-column">
							<div className="user-box white-box bg-white d-none d-xl-block">
								<Stack className="user text-center">
									<Profile />
									<hr className="m-0"></hr>
									<Nav
										variant="tabs"
										defaultActiveKey="/my-Preferences"
										className="user-actions border-0 flex-column text-start"
										onSelect={handleSelect}
									>
										<LeftMenus />
									</Nav>
								</Stack>
							</div>
							{token && !isMobile && (
								<>
									<ConnectionRequestBox />
									{/* <QuickLinksBox /> */}
								</>
							)}
						</div>
						<div className="right-area flex-1 d-flex flex-column">
							<Outlet />
						</div>
						{location.pathname !== '/static/profile' && (
							<div className="social-feed-right">
								<Stack className="social-feed-quick-items">
									{recentMessages?.length > 0 && <RecentMessages />}
									<HashtagsBox />
									{authUser?.userType === USER_TYPES?.SEEKER && <JobsForYou />}
								</Stack>
							</div>
						)}
					</div>
				</Container>
			</section>
		</>
	);
};

export default SocialLayout;
